import React from 'react'
import jslogo from "../../assets/JS Logo Black Empty.png";
import { Link } from 'react-router-dom';
import '../../styles/NavBar.css';


function Navbar() {
  
  return (
    <div className='navbar'>
      <div className='leftSide'>
        <img src={jslogo} alt='jslogo'></img>
      </div>
      <div className='rightSide'>
        <Link to='/'>Home</Link>
        {/* <Link to='/our_showroom'>Our Showroom</Link> */}
        <Link to='/our_team'>Our Team</Link>
        <Link to='/work_with_us'>Work with Us</Link>
        <Link to='/blog'>Blog & Insights</Link>
        <Link to='/partnerwithus'>Partner with Us</Link>
      </div>
    </div>
  )
}

export default Navbar